// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input.is-uppercase[data-v-3210eb10] {\n  text-transform: uppercase;\n}\ninput.is-uppercase[data-v-3210eb10]::-webkit-input-placeholder {\n  text-transform: none;\n}\ninput.is-uppercase[data-v-3210eb10]::-moz-placeholder {\n  text-transform: none;\n}\ninput.is-uppercase[data-v-3210eb10]:-moz-placeholder {\n  text-transform: none;\n}\ninput.is-uppercase[data-v-3210eb10]:-ms-input-placeholder {\n  text-transform: none;\n}\n.is-divider[data-v-3210eb10] {\n  margin: 1.2em 0;\n}", ""]);
// Exports
module.exports = exports;
